var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":"Task colour"}},[_c('div',{staticClass:"control"},[_c('p',{staticClass:"input"},_vm._l((_vm.colors),function(color){return _c('color-dot',{key:color,attrs:{"color":color,"selected":color === _vm.selected},nativeOn:{"click":function($event){return _vm.setColor(color)}}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }